/** Mirrors para-node `InternalDefaultRoles` (`src/constants/internal/internal-role.constants.ts`). */
export enum InternalDefaultRole {
  SuperAdmin = 'super_admin',
  Admin = 'admin',
  Viewer = 'viewer',
  Support = 'support',
  Ops = 'ops',
  Engineering = 'engineering',
  Finops = 'finops',
}

export enum InternalRoleType {
  System = 'system',
  BuiltIn = 'built_in',
  Custom = 'custom',
}

export const internalRoleTypeTitles: Record<InternalRoleType, string> = {
  [InternalRoleType.System]: 'System',
  [InternalRoleType.BuiltIn]: 'Built-in',
  [InternalRoleType.Custom]: 'Custom',
}

/** The backend refuses to RENAME any of these — code and config resolve them by name. */
export const INTERNAL_DEFAULT_ROLE_NAMES: string[] = Object.values(InternalDefaultRole)

/**
 * `INTERNAL_PROTECTED_ROLES`: never modified, never assignable. The backend also checks the
 * role's `isSystem` column, and so does `isProtectedInternalRole`.
 */
export const INTERNAL_PROTECTED_ROLE_NAMES: string[] = [InternalDefaultRole.SuperAdmin]

/** `INTERNAL_ROLE_NAME_MAX_LENGTH` — the column is unbounded, so the editor must enforce it. */
export const INTERNAL_ROLE_NAME_MAX_LENGTH = 64
